import * as Yup from 'yup';

const loginSchema = Yup.object({
  email: Yup.string()
    .label('Sähköpostiosoite')
    .email()
    .nullable()
    .required(),
  password: Yup.string()
    .label('Salasana')
    .required()
});

export default loginSchema;

export type LoginSchema = ReturnType<typeof loginSchema.cast>;
